import React from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';

// import {defineMessages} from 'react-intl';
import {LocalizedDocumentMeta} from 'shared/LocalizedDocumentMeta.jsx';

import Menu, {MenuElements} from '../menu/live';

import BetPanel from '../bet-panel-control';

import ModalWindow from 'shared/components/ModalWindow.jsx';
import ConnectionLost from './../ConnectionLost.jsx';

import {stopFetchStream as stopFetchStreamAction} from 'actions/creators/Stream';
import * as DisplayMode from 'constants/DisplayMode';
import * as ConnectionStatus from 'constants/ConnectionStatus';

import {clearLive as clearLiveAction} from 'actions/creators/Live';

import {clearTimetable as clearTimetableAction} from 'actions/creators/Timetable';

import {setDisplayMode as setDisplayModeAction} from 'actions/creators/SetDisplayMode';
import {getPeriodInfo} from '../grid-control/sportGlossary/utils';
import * as PeriodType from 'constants/Period';

import {
    toggleFavouriteSport as toggleFavouriteSportAction,
    toggleFavouriteLeague as toggleFavouriteLeagueAction,
    toggleFavouriteMatch as toggleFavouriteMatchAction
} from 'actions/creators/Favourites';

import {
    toggleSportLive as toggleSportLiveAction,
    toggleLeagueLive as toggleLeagueLiveAction,
    showAllLive as showAllLiveAction
} from 'actions/creators/UserSelection';

import StreamPanel from '../stream/StreamPanel.jsx';
import BetradarWidget from './Stream/BetradarWidget.jsx';
import { getMetadata } from '../../../shared/metadata/metadata'

function fetchDisplayMode(props) {
    const defaultDisplayMode = {type: DisplayMode.ALL};

    if (props.gridSelection === undefined || !props.gridSelection) {
        return defaultDisplayMode;
    }

    let newDisplayMode;
    const displayModeAttr = props.gridSelection.get('lastShown');

    if (!displayModeAttr) {
        newDisplayMode = defaultDisplayMode;
    } else {
        if (displayModeAttr.has('sportId')) {
            newDisplayMode = {type: DisplayMode.SPORT, id: displayModeAttr.get('sportId')};
        }

        if (displayModeAttr.has('leagueId')) {
            newDisplayMode = {type: DisplayMode.LEAGUE, id: displayModeAttr.get('leagueId')}
        }
    }

    return newDisplayMode;
}

class LivePage extends React.Component {
    static propTypes = {
        center: React.PropTypes.any.isRequired,
        languageId: React.PropTypes.number.isRequired,
        connectionStatus: React.PropTypes.number.isRequired,
        gridSelection: React.PropTypes.object.isRequired,
        gridLocalization: React.PropTypes.object.isRequired,
        clearLiveAction: React.PropTypes.func.isRequired,
        clearTimetableAction: React.PropTypes.func.isRequired,
        setDisplayModeAction: React.PropTypes.func.isRequired,
        toggleFavouriteSportAction: React.PropTypes.func.isRequired,
        toggleFavouriteLeagueAction: React.PropTypes.func.isRequired,
        toggleFavouriteMatchAction: React.PropTypes.func.isRequired,
        toggleSportLiveAction: React.PropTypes.func.isRequired,
        toggleLeagueLiveAction: React.PropTypes.func.isRequired,
        showAllLiveAction: React.PropTypes.func.isRequired,
        user: React.PropTypes.any,
        activeWidgetId: React.PropTypes.any,
        isShortcut: React.PropTypes.any,
        matchIsBlocked: React.PropTypes.any,
        push: React.PropTypes.func.isRequired,
        stream: React.PropTypes.object.isRequired,
        streamName: React.PropTypes.any,
        stopFetchStreamAction: React.PropTypes.func.isRequired,
    };

    constructor(props, context) {
        super(props, context);

        this._menuShowAll = this._menuShowAll.bind(this);
        this._menuShowFavourites = this._menuShowFavourites.bind(this);
        this._sportClick = this._sportClick.bind(this);
        this._sportFavouriteClick = this._sportFavouriteClick.bind(this);
        this._leagueClick = this._leagueClick.bind(this);
        this._leagueFavouriteClick = this._leagueFavouriteClick.bind(this);
        this._matchClick = this._matchClick.bind(this);
        this._matchFavouriteClick = this._matchFavouriteClick.bind(this);
        this._connectionLostCloseClick = this._connectionLostCloseClick.bind(this);

        this.state = {
            dismissConnectionLost: false
        };
    }

    componentWillMount() {
        this.props.setDisplayModeAction(fetchDisplayMode(this.props));
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.gridSelection.get('lastShown') !== nextProps.gridSelection.get('lastShown')) {
            this.props.setDisplayModeAction(fetchDisplayMode(nextProps));
        }
    }

    componentWillUnmount() {
        this.props.clearLiveAction();
        this.props.clearTimetableAction();
    }

    _menuShowFavourites() {
        this.props.push('/live');
        this.props.setDisplayModeAction({type: DisplayMode.FAVOURITE});
    }

    _menuShowAll() {
        this.props.push('/live');
        this.props.setDisplayModeAction({type: DisplayMode.ALL});
        this.props.showAllLiveAction();
    }

    _sportClick(id) {
        this.props.push('/live');
        this.props.setDisplayModeAction({type: DisplayMode.SPORT, id});
    }

    _sportFavouriteClick(sport) {
        this.props.toggleFavouriteSportAction(sport);
    }

    _leagueClick(sportId, id) {
        this.props.push('/live');
        this.props.setDisplayModeAction({type: DisplayMode.LEAGUE, id});
    }

    _leagueFavouriteClick(league) {
        this.props.toggleFavouriteLeagueAction(league);
    }

    _matchClick(id) {
        this.props.push('/live');
        this.props.setDisplayModeAction({type: DisplayMode.MATCH, id});
    }

    _matchFavouriteClick(match) {
        this.props.toggleFavouriteMatchAction(match);
    }

    _connectionLostCloseClick() {
        const state = this.state;

        this.setState({
            ...state,
            dismissConnectionLost: true
        });
    }

    render() {
        const {
            connectionStatus,
            gridSelection,
            gridLocalization,
            isShortcut,
            toggleSportLiveAction,
            toggleLeagueLiveAction,
            user,
            stream,
            streamName,
            matchIsBlocked,
            countryCode,
        } = this.props;
        const {dismissConnectionLost, selectedMenuItem} = this.state;

        const menu = {
            ...MenuElements,
            selectedItem: selectedMenuItem,
            showSlider: true,
            showBookmarks: true,
            showCalendar: true,
            showMatches: true,
            showAllSports: true,
            gridSelection: gridSelection,
            showFavouritesCallback: this._menuShowFavourites,
            showAllCallback: this._menuShowAll,
            sportClickCallback: this._sportClick,
            sportFavouriteClickCallback: this._sportFavouriteClick,
            leagueClickCallback: this._leagueClick,
            leagueFavouriteClickCallback: this._leagueFavouriteClick,
            matchClickCallback: this._matchClick,
            matchFavouriteClickCallback: this._matchFavouriteClick,
            selectionToggleCallback: toggleSportLiveAction,
            selectionToggleLeagueCallback: toggleLeagueLiveAction,
            isShortcut
        };

        const withProps = React.cloneElement(this.props.center, {gridLocalization, section: 'live'});

        const metadata = getMetadata(countryCode, null, 'live');

        return (
            <div className="no-scroll-wrapper">
                <LocalizedDocumentMeta title={metadata.title} description={metadata.description} keywords={metadata.keywords}/>
                <div id="left" className='live-left'>
                    <Menu {...menu} />
                </div>
                <div id="right">
                    <BetradarWidget />
                    {(user && !matchIsBlocked && stream.src) && <StreamPanel stream={stream}
                                 stopFetchStreamAction={this.props.stopFetchStreamAction}
                                 streamName={streamName}
                                 user={user}/>}
                    <BetPanel />
                </div>
                <div id="center" className='live-center'>
                    {withProps}
                </div>
                {connectionStatus === ConnectionStatus.DISCONNECTED && !dismissConnectionLost &&
                <ModalWindow><ConnectionLost onClose={this._connectionLostCloseClick}/></ModalWindow>}
            </div>
        );
    }
}

function select(state, props) {
    const languageId = state.application.get('languageId');
    const connectionStatus = state.application.get('connectionStatus');
    const gridSelection = state.application.getIn(['userGridSelection', 'live']);
    const user = state.auth.get('user');
    const stream = state.application.get('stream');
    const activeWidgetId = state.application.get('betradar').activeWidgetId;
    const countryCode = state.application.get('countryCode');
    const match = state.application.getIn(['live', 'matches', state.application.get('stream').matchId]);

    let matchIsBlocked = true;
    let streamName = '';
    if (match) {
        const periodInfo = getPeriodInfo(match, props.gridLocalization);
        const matchPhase = periodInfo.matchPhase;
        matchIsBlocked = matchPhase === PeriodType.FINISHED;
        streamName = match.get('name') ? match.get('name') : '';
    }

    return {
        languageId,
        connectionStatus,
        gridSelection,
        user,
        stream,
        streamName,
        matchIsBlocked,
        activeWidgetId,
        countryCode
    };
}

export default connect(select, {
    clearLiveAction,
    clearTimetableAction,
    setDisplayModeAction,
    toggleFavouriteSportAction,
    toggleFavouriteLeagueAction,
    toggleFavouriteMatchAction,
    toggleSportLiveAction,
    toggleLeagueLiveAction,
    showAllLiveAction,
    push,
    stopFetchStreamAction,
})(LivePage);



// WEBPACK FOOTER //
// ./js/sport-betting/components/pages/LivePage.jsx